import "./views/opening-hours-bar";